import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;


// ── ADD PROJECT ──────────────────────────────────────────────────────────────
export const addProjectResale = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_PROJECT_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/project-add`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_PROJECT_RESALE_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "ADD_PROJECT_RESALE_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "ADD_PROJECT_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// ── LIST PROJECTS ────────────────────────────────────────────────────────────
export const listProjectResale = (projectData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_PROJECT_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/project-list`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "LIST_PROJECT_RESALE_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_PROJECT_RESALE_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_PROJECT_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// ── VIEW PROJECT ─────────────────────────────────────────────────────────────
export const viewProjectResale = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "VIEW_PROJECT_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/project-resale/view-project/${id}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_PROJECT_RESALE_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "VIEW_PROJECT_RESALE_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_PROJECT_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// ── UPDATE PROJECT ───────────────────────────────────────────────────────────
export const updateProjectResale = (id, projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_PROJECT_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/project-update`,
        { ...projectData, id },
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_PROJECT_RESALE_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "UPDATE_PROJECT_RESALE_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_PROJECT_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// ── STATUS UPDATE ────────────────────────────────────────────────────────────
export const statusProjectResale = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "STATUS_PROJECT_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/project-status`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "STATUS_PROJECT_RESALE_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "STATUS_PROJECT_RESALE_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "STATUS_PROJECT_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// ── PROJECT PROPERTY LINK ────────────────────────────────────────────────────
export const projectPropertyLinkResale = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "PROJECT_PROPERTY_LINK_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/project-property-link`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "PROJECT_PROPERTY_LINK_RESALE_SUCCESS", payload: data });
        toast.success(data?.message);
        return data;
      } else {
        dispatch({ type: "PROJECT_PROPERTY_LINK_RESALE_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "PROJECT_PROPERTY_LINK_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// ── UPDATE PROJECT PROPERTY LINK ─────────────────────────────────────────────
export const updateProjectPropertyLinkResale = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_PROJECT_PROPERTY_LINK_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/project-property-link-update`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_PROJECT_PROPERTY_LINK_RESALE_SUCCESS",
          payload: data,
        });
        toast.success(data?.message);
        return data;
      } else {
        dispatch({
          type: "UPDATE_PROJECT_PROPERTY_LINK_RESALE_FAILED",
          payload: data,
        });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_PROJECT_PROPERTY_LINK_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listResaleInterestedProject = (projectData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_RESALE_INTERESTED_PROJECT_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/resale-interested-project/list`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "LIST_RESALE_INTERESTED_PROJECT_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_RESALE_INTERESTED_PROJECT_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "LIST_RESALE_INTERESTED_PROJECT_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateStatusResaleInterestedProject = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_STATUS_RESALE_INTERESTED_PROJECT_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/resale-interested-project/status/update`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "UPDATE_STATUS_RESALE_INTERESTED_PROJECT_SUCCESS",
          payload: data,
        });
        // toast.success(data?.message);
        return data;
      } else {
        dispatch({
          type: "UPDATE_STATUS_RESALE_INTERESTED_PROJECT_FAILED",
          payload: data,
        });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_STATUS_RESALE_INTERESTED_PROJECT_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// ── PROPERTY LIST (for admin + linking) ─────────────────────────────────────
export const listPropertyResale = (propertyData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "LIST_PROPERTY_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/property-list`,
        propertyData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({
          type: "LIST_PROPERTY_RESALE_SUCCESS",
          payload: data,
        });
        return data;
      } else {
        dispatch({
          type: "LIST_PROPERTY_RESALE_FAILED",
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: "LIST_PROPERTY_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// ── SYNC PROJECT PROPERTY LINK (add + update in one) ─────────────────────────
export const syncProjectPropertyLinkResale = (projectData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "SYNC_PROJECT_PROPERTY_LINK_RESALE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(
        `${BASE_URL}/project-resale/project-property-link-sync`,
        projectData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "SYNC_PROJECT_PROPERTY_LINK_RESALE_SUCCESS", payload: data });
        toast.success(data?.message);
        return data;
      } else {
        dispatch({ type: "SYNC_PROJECT_PROPERTY_LINK_RESALE_FAILED", payload: data });
        toast.error(data?.message);
      }
    } catch (error) {
      dispatch({
        type: "SYNC_PROJECT_PROPERTY_LINK_RESALE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      // dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getUserEnquiriesList = (enquiryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_ENQUIRIES_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project-resale/user-list`,
        enquiryData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_ENQUIRIES_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_ENQUIRIES_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_ENQUIRIES_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};